import { EnvironmentCodeDTO } from 'csr-login-app';

/** Clean HSBC sustainability URL (not an Outlook safelink). */
export const BSAT_REGISTRATION_CLOSED_REDIRECT_URL = 'https://www.business.hsbc.com/en-gb/products/sustainability';

/** Query param to force the closed registration UI for local/QA testing. */
export const BSAT_REGISTRATION_CLOSED_QUERY_PARAM = 'forceBsatRegistrationClosed';

/** Midnight Europe/London on 29 Oct 2026 (UK is on GMT that day). */
const BSAT_REGISTRATION_CLOSED_FROM = Date.parse('2026-10-29T00:00:00+00:00');

const BSAT_REGISTRATION_ENVIRONMENTS: ReadonlySet<EnvironmentCodeDTO> = new Set([
  EnvironmentCodeDTO.HSBC,
  EnvironmentCodeDTO.HSBCGLOBAL,
  EnvironmentCodeDTO.HSBCGLOBALPRO
]);

export function isBsatRegistrationEnvironment(environmentCode: EnvironmentCodeDTO): boolean {
  return BSAT_REGISTRATION_ENVIRONMENTS.has(environmentCode);
}

/**
 * True when new BSAT user registration must be closed for this HSBC environment.
 * Non-BSAT environments (e.g. ING ref, HSBC retail) always return false.
 * Append `?forceBsatRegistrationClosed=1` to preview the closed UI before the cutoff.
 */
export function isBsatRegistrationClosed(environmentCode: EnvironmentCodeDTO, now: Date = new Date()): boolean {
  if (!isBsatRegistrationEnvironment(environmentCode)) {
    return false;
  }

  if (hasForceBsatRegistrationClosedQueryParam()) {
    return true;
  }

  return now.getTime() >= BSAT_REGISTRATION_CLOSED_FROM;
}

function hasForceBsatRegistrationClosedQueryParam(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const value = new URLSearchParams(window.location.search).get(BSAT_REGISTRATION_CLOSED_QUERY_PARAM);
  return value === '1' || value === 'true';
}
